module.exports = __webpack_public_path__ + "static/media/Tiger_Main.fa78a177.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tiger_Main.webp
// module id = ./src/assets/Tiger_Main.webp
// module chunks = 0